/* Built In Imports */
import NextLink from 'next/link';
import React, { useEffect, useState } from 'react';
/* External Imports */
import { Box, Flex, Button, Link } from '@chakra-ui/react';
import { render } from 'datocms-structured-text-to-html-string';

/* Internal Imports */
/* Components */
import { isOpenInNewTab, refineUrlDomain } from '@moms/Utility/utils';
import config from '@config';
import StructuredTextParser from '@moms/Utility/StructuredTextParser';
import ProvenBySt from '@moms/styleData/ProvenBySt';
/* Styles */
/* Services */

/**
 *
 * @param {Object} sectionContent
 * @param {String} region
 * @param {String} lang
 * @returns
 */

const VideoContent = ({ region, lang, sectionContent }) => {
  const [navigatorObj, setNavigatorObj] = useState(true);
  let iOS = false;

  const iPhoneScreenHide = () => {
    var elVideo = document.getElementById('video');
    iOS = /iPad|iPhone|iPod/.test(navigator?.userAgent) && !window.MSStream;
    setNavigatorObj(navigator.userAgent);
    if (iOS) {
      elVideo.style.display = 'none';
    }
  };
  useEffect(() => {
    iPhoneScreenHide();
  }, []);

  return (
    <Box
      pos="absolute"
      top={0}
      left={0}
      right={0}
      bottom={0}
      w="100%"
      height="100%"
      id="video"
      zIndex={1}
    >
      <Box
        as="video"
        width="100%"
        height="100%"
        loop
        muted
        autoPlay
        objectFit="cover"
      >
        <source
          src={`${config.imgPath}/d/46272/1740037482-2e44110987c19d60014c9e57cb34972f.mp4`}
          type="video/mp4"
        />
        Your browser does not support the video tag.
      </Box>
    </Box>
  );
};

const TextContent = ({ region, lang, sectionContent }) => {
  const numStudies = sectionContent.find(el => el.fieldId === 'num-studies');
  const studies = sectionContent.find(el => el.fieldId === 'studies');
  const byResearchers = sectionContent.find(
    el => el.fieldId === 'by-researchers'
  );
  const worldClass = sectionContent.find(el => el.fieldId === 'world-class');
  const haveEstab = sectionContent.find(el => el.fieldId === 'have-estab');
  const meditationOfferings = sectionContent.find(
    el => el.fieldId === 'meditation-offerings'
  );
  return (
    <Box
      maxW={1220}
      w="100%"
      mx="auto"
      px="1rem"
      py={{ base: '3rem', md: '8rem' }}
      pos="relative"
      zIndex={2}
    >
      <Flex
        w="100%"
        height="100%"
        gap={{ base: '0', md: '2.5rem' }}
        justifyContent="center"
        flexWrap={{ base: 'wrap', lg: 'nowrap' }}
        flexDir={{ base: 'column', lg: 'row' }}
      >
        <Flex
          flex="1"
          alignItems={{ base: 'flex-start', md: 'center' }}
          flexDir={{ base: 'column', md: 'row' }}
          flexWrap={{ base: 'wrap', md: 'nowrap' }}
        >
          <Box mr="3rem">
            <StructuredTextParser
              str={render(numStudies.body)}
              region={region}
              lang={lang}
              mt="0"
              {...ProvenBySt[lang].numText}
            />
            <StructuredTextParser
              str={render(studies.body)}
              region={region}
              lang={lang}
              {...ProvenBySt[lang]?.stuText}
              mt="-2rem"
              marginTop={{ base: '-1.8rem', md: '-2rem' }}
              marginBottom={{ base: '55px', md: '' }}
            />
          </Box>
          <Box>
            <StructuredTextParser
              str={render(byResearchers.body)}
              region={region}
              lang={lang}
              {...ProvenBySt[lang].byRText}
              w={{ base: '100%', md: '300px' }}
            />
            <StructuredTextParser
              str={render(worldClass.body)}
              region={region}
              lang={lang}
              {...ProvenBySt[lang].worText}
              w={{ base: '100%', md: '300px' }}
            />
          </Box>
        </Flex>
        <Box
          mt={{ base: '1.3rem', md: '0' }}
          mb={{ base: '1.5rem', md: '0' }}
          w={{ base: '100%', lg: '1px' }}
          bg={{
            base: 'rgba(255, 255, 255, 0.40)',
            md: 'rgba(255, 255, 255, 0.40)',
            lg: 'rgba(255, 255, 255, 0.40)',
          }}
          height={{ base: '1px', lg: 'auto' }}
          maxW={{ base: 218, lg: 1 }}
        ></Box>
        <Flex flex="1" flexDir="column" justifyContent="center">
          <Box>
            <StructuredTextParser
              str={render(haveEstab.body)}
              region={region}
              lang={lang}
              {...ProvenBySt[lang].havText}
              mt="0"
              mx="0"
            />
            <StructuredTextParser
              str={render(meditationOfferings.body)}
              region={region}
              lang={lang}
              {...ProvenBySt[lang].medText}
              mt="0"
              mx="0"
            />
          </Box>
        </Flex>
      </Flex>
        {/* lower button */}
        <LowerButton
          region={region}
          lang={lang}
          sectionContent={sectionContent}
        />
    </Box>
  );
};

const LowerButton = ({ region, lang, sectionContent }) => {
  const buttonData =
    sectionContent.find(item => item._modelApiKey === 'simple_button') ||
    sectionContent?.[1];

  return (
    <>
    {buttonData && (
      <Box
        color="#fff"
        background="none"
        paddingInline={{ base: '20px', md: '100px' }}
        pt={{ base: '60px' }}
        display="flex"
        justifyContent="center"
        alignItems="center"
        m="0 auto"
      >
        <Link
          href={refineUrlDomain(buttonData?.linkUrl, region, lang)}
          passHref
          width={{ base:'100%', md:'auto'}}
          _hover={{ textDecoration: 'none', border: 'none'}}
        >
          <Button
            target={isOpenInNewTab(buttonData?.linkUrl) ? '_blank' : ''}
            height="auto"
            as={Link}
            rel="noopener noreferrer"
            fontWeight={600}
            borderWidth={'1px'}
            width={{ base: '100%', md: '295px' }}
            borderRadius={'55px'}
            fontFamily="Geist"
            color={'#FFFFFF'}
            fontSize="18px"
            display="flex"
            alignItems="center"
            p="1rem"
            bgColor={'transparent'}
            minW="250px"
            // maxW={}
            _hover={{ bgColor: '#FFFFFF1A', textDecor: 'none' }}
            letterSpacing="-0.54px"
            {...ProvenBySt[lang].buttonText} // style matching this button with inner button
          >
            {buttonData?.buttonText}
          </Button>
        </Link>
      </Box>
    )}
    </>
  );
};

const StudiesDone = ({ sectionContent, region, lang }) => {
  return (
    <>
    <Box
      w="100%"
      bg="#000"
      bgImage={`${config.imgPath}/d/46272/1740374778-transition-motion-10.jpg`}
      bgPos="center"
      bgRepeat="no-repeat"
      bgSize="cover"
      pos="relative"
      _after={{
        content: "''",
        pos: 'absolute',
        height: '0.6px',
        left: '0',
        right: '0',
        width: '100%',
        bottom: '0',
        zIndex: '1',
        background:
          'radial-gradient(80.14% 21.43% at 50% 50%, rgba(0, 0, 0, 0.40) 0%, rgba(0, 0, 0, 0.00) 100%), #010102',
        backdropFilter: 'blur(calc(var(--sds-size-blur-100) / 2))',
        borderTop: '1px solid rgba(255, 255, 255, 0.20)',
      }}
      px={{ md: '1.5rem' }}
      py={{ base: '4.5rem', md: '0' }}
    >
      {/* video */}
      <VideoContent
        region={region}
        lang={lang}
        sectionContent={sectionContent}
      />

      {/* text content */}
      <TextContent
        region={region}
        lang={lang}
        sectionContent={sectionContent}
      />
    </Box>
    </>
  );
};

export default StudiesDone;
